import script from "./cardApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./cardApplication.vue?vue&type=script&setup=true&lang=js"

import "./cardApplication.vue?vue&type=style&index=0&id=66fe2772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fe2772"]])

export default __exports__